/**
 * The head values `public/index.html` ships with.
 *
 * These have to be stated, not read from the document. Article routes are
 * prerendered, so on a direct visit to an article the document already carries that
 * article's title and description before any React code runs. Capturing "whatever
 * was there on mount" would therefore capture the article's own values, and
 * navigating back to the homepage would restore the article's title onto it.
 *
 * Kept in step with index.html by shellHead.test.js.
 */

export const SHELL_TITLE = 'Mixtape Memories — Funeral & Memorial Video Maker';

export const SHELL_DESCRIPTION =
  'Make a memorial video from the photos and songs that mattered. Guided templates, a preview before you pay, and a Full-HD download.';

export const SHELL_URL = 'https://mixtapememories.app';

export const SHELL_OG_TYPE = 'website';

/** Absolute, because link-preview scrapers do not resolve relative paths. */
export const SHELL_IMAGE = 'https://mixtapememories.app/og-image.jpg';

/** The site card's og:image:alt, restored when leaving a page that set its own image. */
export const SHELL_IMAGE_ALT = 'Mixtape Memories — memorial videos, made simple';
